module.exports = __webpack_public_path__ + "static/media/Smart Extrude – Smarter than your Average Bear.d44a00b9.png";